export default "__VITE_ASSET__BkIDZMb3__"